import ApzCheckoutPage from "./ApzCheckoutPage"

export default ApzCheckoutPage
